import { Link } from "wouter";
import { Instagram, Facebook, Linkedin, Youtube, ArrowUpRight } from "lucide-react";

export function Footer() {
  const baseUrl = import.meta.env.BASE_URL;

  return (
    <footer id="contact" className="bg-zinc-950 pt-32 pb-12 border-t border-white/5 relative">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24">
          <div className="space-y-8">
            <h2 className="font-display text-5xl md:text-7xl font-bold uppercase">
              Let's Talk.
            </h2>
            <a 
              href="mailto:Contact@blackswanproductions.co.uk"
              className="inline-flex items-center gap-3 md:gap-4 text-base sm:text-xl md:text-3xl text-gray-400 hover:text-white transition-colors duration-300 group break-all"
            >
              Contact@blackswanproductions.co.uk
              <ArrowUpRight className="w-6 h-6 md:w-8 md:h-8 shrink-0 text-primary group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </div>
          
          <div className="flex flex-col md:items-end space-y-8">
            <img loading="lazy" decoding="async" 
              src={`${baseUrl}brand/logo-secondary.png`} 
              alt="Black Swan" 
              className="h-16 object-contain opacity-50"
            />
            <div className="flex gap-6">
              <a href="https://www.instagram.com/blackswan_productions/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-primary hover:border-primary transition-colors duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/blackswanproductionsltd" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-primary hover:border-primary transition-colors duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/blackswanproductions/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-primary hover:border-primary transition-colors duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@BlackSwanProductions/videos" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-primary hover:border-primary transition-colors duration-300">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/10 text-sm text-gray-400">
          <p>
            © Black Swan Productions 2026. All rights reserved.
            <span className="mx-2 text-gray-400">·</span>
            <Link
              href="/terms-and-conditions"
              className="text-gray-400 underline underline-offset-4 decoration-gray-400/60 hover:text-primary hover:decoration-primary transition-colors duration-300"
            >
              Terms and Conditions
            </Link>
            <span className="mx-2 text-gray-400">·</span>
            <Link
              href="/terms-and-conditions-supply-of-services"
              className="text-gray-400 underline underline-offset-4 decoration-gray-400/60 hover:text-primary hover:decoration-primary transition-colors duration-300"
            >
              Terms of Supply
            </Link>
            <span className="mx-2 text-gray-400">·</span>
            <Link
              href="/privacy-policy"
              className="text-gray-400 underline underline-offset-4 decoration-gray-400/60 hover:text-primary hover:decoration-primary transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <span className="mx-2 text-gray-400">·</span>
            Created by{" "}
            <a
              href="https://www.d3-digital.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 underline underline-offset-4 decoration-gray-400/60 hover:text-primary hover:decoration-primary transition-colors duration-300"
            >
              D3 Digital
            </a>
          </p>
          <p className="mt-4 md:mt-0 uppercase tracking-widest font-semibold text-xs">Great Point Studios, Wentloog Ave, Cardiff, CF3 2GH</p>
        </div>
      </div>
    </footer>
  );
}
